var _defs, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTceTitle = function SvgTceTitle(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 70,
    viewBox: "0 0 300 70",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 300,
    height: 70,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-381 -20)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(353.188 -27)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22 42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.942 10.547)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.13, -5.55)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 472,
    height: 52,
    rx: 4,
    transform: "translate(9 6)",
    fill: "#233d43"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17 4)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(94.813 11)",
    fill: "#fff",
    fontSize: 26,
    fontFamily: "Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 30
  }, "Flood Explorer")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.813 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 58,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.879 9.761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.42,8C11.768,8,8,12.048,8,17.046s3.768,9.046,8.42,9.046,8.42-4.048,8.42-9.046S21.073,8,16.42,8Zm0,13.57a4.388,4.388,0,0,1-4.21-4.523,4.388,4.388,0,0,1,4.21-4.523,4.388,4.388,0,0,1,4.21,4.523A4.388,4.388,0,0,1,16.42,21.57Z",
    transform: "translate(2.826 3.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.492,13.189V8.853A64.835,64.835,0,0,0,21.246,6.091a14.882,14.882,0,0,0-10.662,4.582A55.58,55.58,0,0,1,12.527,2H8.447a77.176,77.176,0,0,0-2.6,20.456A16.854,16.854,0,0,0,10.16,33.788,49.2,49.2,0,0,1,2,31.722v4.337A64.835,64.835,0,0,0,21.246,38.82a14.882,14.882,0,0,0,10.662-4.582,57.953,57.953,0,0,1-1.944,8.673h4.08a77.177,77.177,0,0,0,2.6-20.456,16.854,16.854,0,0,0-4.311-11.332A47.189,47.189,0,0,1,40.492,13.189ZM21.246,34.729c-6.37,0-11.548-5.5-11.548-12.273s5.177-12.273,11.548-12.273,11.548,5.5,11.548,12.273S27.616,34.729,21.246,34.729Z",
    transform: "translate(-2 -2)",
    fill: "#fff"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTceTitle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tce-title.ac37fa34.svg";
export { ForwardRef as ReactComponent };